// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-file-FileList-module__multiple--aA7R6 {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/file/FileList.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".multiple {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiple": `src-common-attributes-makeAttrLabel-labelMakers-file-FileList-module__multiple--aA7R6`
};
export default ___CSS_LOADER_EXPORT___;
